<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        支店管理　
        <div class="headerBtn" @click="add">新規登録</div>
        <div class="headerBtn" @click="bulkAdd">一括登録</div>
      </div>

      <div class="row">
        <p class="inputTitle condition">支店名</p>
        <multiselect
          v-model="branchNameCondition"
          :options="branchNameOptions"
          :close-on-select="false"
          :multiple="true"
          :taggable="true"
          label="branchName"
          track-by="branchId"
          placeholder="検索したい支店名を選択"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          style="margin: auto"
        >
        <span slot="noOptions"></span>
        </multiselect>
        <!-- 選択されたタグの情報確認用 -->
        <!-- <pre class="language-json"><code>{{ siteCondition  }}</code></pre> -->
      </div>

      <div class="row">
        <p class="inputTitle condition">メールアドレス</p>
        <multiselect
          v-model="emailCondition"
          :options="emailOptions"
          :multiple="true"
          :taggable="true"
          label="name"
          track-by="code"
          placeholder="検索したいメールアドレスを入力"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          style="margin: auto"
          @tag="addEmailTag">
        >
        <span slot="noOptions"></span>
        </multiselect>
        <!-- 選択されたタグの情報確認用 -->
        <!-- <pre class="language-json"><code>{{ siteCondition  }}</code></pre> -->
      </div>

      <div class="searchBtn" @click="search()">検索</div>

      <!-- 取得ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- APIエラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 削除エラー表示 -->
      <div v-if="deleteErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの削除中に問題が発生しました。
          </div>
        </div>
      </div>
      <!-- 現在表示件数 / 検索結果最大件数 -->
      <div style="text-align:right" v-if="!getLodingFlg && !getErrorFlg">
        <div v-if="limit * currentPage <= conditionRow.length">
          {{(limit * currentPage) - (limit - 1)}} - {{limit * currentPage}} / {{conditionRow.length}} 件
        </div>
        <div v-else>
          {{(limit * currentPage) - (limit - 1)}} - {{conditionRow.length}} / {{conditionRow.length}} 件
        </div>
      </div>
      <vue-good-table
        :columns='columns'
        :rows='conditionRow'
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          mode: 'pages',
          perPage: 100,
          position: 'top',
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: '次へ',
          prevLabel: '前へ',
          rowsPerPageLabel: '表示する行数',
          ofLabel: '/',
          pageLabel: 'ページ',
          allLabel: 'All',
        }"
        :group-options="{
          enabled: false
        }"
        @on-page-change="onPageChange"
        v-if="!getLodingFlg && !getErrorFlg"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'operation'" style="display: flex;">
            <div class="edit" @click="edit(props.formattedRow)">編集</div>
            <div class="remove" @click="openModal(props.formattedRow)">削除</div>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
        </template>
        <div slot="emptystate">データがありません</div>
      </vue-good-table>
      <button type="button" class="csvBtn" @click="callOutputCsv()"
        :disabled="!csvDlFlg && conditionRow.length > csvLimit"
        v-bind:class="{
          disabled: !csvDlFlg && conditionRow.length > csvLimit,
          active: csvDlFlg && conditionRow.length <= csvLimit
        }"
      >
        表示中のデータをCSV形式でダウンロード
      </button>
      <div style="text-align:right">
        ※CSVダウンロード件数は最大{{csvLimit}}件になります。<br>
        　件数を超えている場合は検索条件にて絞り込みを行ってください。
      </div>
    </div>
    <!-- 削除ローディング -->
    <div v-if="deleteLodingFlg">
      <vue-loading
        type="cylon"
        color="#1b7e47"
        :size="{ width: '150px', height: '150px' }"
      >
      </vue-loading>
      <div style="padding: 0px 0px 30px 0px;">Now Deleting...</div>
    </div>
    <!-- 削除モーダル画面 -->
    <Modal size="delete" @close="closeModal" v-if="modal">
    <!-- 削除ローディング -->
    <div v-if="deleteLodingFlg">
      <vue-loading
        type="cylon"
        color="#1b7e47"
        :size="{ width: '150px', height: '150px' }"
      >
      </vue-loading>
      <div style="padding: 0px 0px 30px 0px;">Now Deleting...</div>
    </div>
      <p class="modalTitle">削除しますか？</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>
          本当に {{selectRow.branchName}} の支店情報を削除してよろしいですか？<br>
          一度削除したデータは復旧出来ませんので、ご了承下さい。
        </p>
      </div>
      <button @click.once="deleteExecution()" class="modalYes">削除する</button>
      <button @click="closeModal(3)" class="modalNo" style="margin: 50px 0px 0px 30px;">キャンセル</button>
    </Modal>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import '../style/vue-good-table.scss';
import { VueGoodTable } from 'vue-good-table';
import Modal from './BaseModal.vue';
import common from '../services/common';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';

const defaultSettings = {
  placeholder: '',
  selectLabel: '',
  deselectLabel: '',
  selectedLabel: '',
  noDataLabel: '対象データがありません',
};

export default {
  title: '支店一覧',
  name: 'branch',
  components: {
    VueGoodTable,
    Modal,
    VueLoading,
  },
  data() {
    return {
      companyId: '',
      branchNameOptions: [],
      branchNameCondition: [],
      emailOptions: [],
      emailCondition: [],
      modal: false,
      getLodingFlg: false,
      getErrorFlg: false,
      deleteLodingFlg: false,
      deleteErrorFlg: false,
      csvDlFlg: false,
      errorMessage: '',
      columns: [
        {
          label: 'ID',
          field: 'branchId',
          sortable: false,
          hidden: true,
        },
        {
          label: '支店名',
          field: 'branchName',
          sortable: true,
          width: '250px',
        },
        {
          label: 'ログインID',
          field: 'loginId',
          sortable: true,
          width: '170px',
        },
        {
          label: 'メールアドレス',
          field: 'email',
          sortable: true,
          width: '250px',
        },
        {
          label: '',
          field: 'operation',
          sortable: false,
          width: '145px',
        },
      ],
      rows: [],
      conditionRow: [],
      selectRow: {},
      // 検索上限
      limit: 100,
      // 検索内容最大件数
      maxCount: 0,
      // 現在ページ
      currentPage: 1,
      // 現在ページ
      inputPage: 1,
      // 最大ページ数
      maxPage: 1,
      // CSV取得上限
      csvLimit: 10000,
    };
  },
  // 初期処理
  async mounted() {
    // セッション情報からログイン事業者IDを取得
    this.companyId = this.$store.getters.session.companyId;
    try {
      // ローディング表示
      this.getLodingFlg = true;
      // 支店一覧取得
      this.rows = await this.callGetBranches();
      // 初期データをセット
      this.conditionRow = this.rows;
      // テーブルが空の場合CSVダウンロードを非活性
      this.csvDlFlg  = (this.conditionRow.length > 0) ? true : false;
      // 支店名一覧取得
      this.branchNameOptions = await this.callGetBranchNameList();
      // URL検索条件確認
      this.branchNameCondition = common.getUrlParam('branchName', 0);
      this.emailCondition = common.getUrlParam('email', 0);
      // 検索処理呼出
      this.search();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 支店一括取得API呼出
    async callGetBranches() {
      try {
        const restResourceService = new ApiClient();
        const resultRows = await restResourceService.getBranches(this.companyId);
        return resultRows;
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
    // 支店名リスト取得API呼出
    async callGetBranchNameList() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getBranchesNameList(this.companyId);
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        throw error;
      }
    },
    // Email検索条件追加
    addEmailTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000)),
      };
      this.emailCondition.push(tag);
      this.emailOptions.push(tag);
    },
    // 検索ボタン押下時
    search() {
      // 検索条件でテーブルにフィルターをかける
      this.setCondition(this.rows);
      // 検索条件を取得
      common.setUrlParam('branchName', this.branchNameCondition, 0);
      common.setUrlParam('email', this.emailCondition, 0);
      // テーブルが空の場合CSVダウンロードを非活性
      this.csvDlFlg = (this.conditionRow.length > 0) ? true : false;
    },
    // 一覧上部の検索条件を一覧へ反映
    setCondition(rows) {
      if (this.branchNameCondition.length === 0 && this.emailCondition.length === 0) {
        // 検索条件がない場合、初期データを書き戻す
        this.conditionRow = rows;
        return;
      }
      let newRows = [];
      let tempRows = rows;
      this.conditionRow = [];

      // 検索条件：支店を検索
      if (this.branchNameCondition.length !== 0) {
        // 検索条件に合うレコードを取得
        this.conditionRow = common.searchConditionName(this.branchNameCondition, tempRows, 'branchName');
        tempRows = this.conditionRow;
      }

      // 検索条件：メールアドレスを検索(部分一致)
      newRows = [];
      this.emailCondition.forEach(
        (email) => {
          const tempRow = tempRows.filter((v) =>
            v.email.match(email.name),
          );
          if (tempRow.length !== 0) {
            Array.prototype.push.apply(newRows, tempRow);
          }
        },
      );
      if (newRows.length !== 0) {
        // Array.prototype.push.apply(this.conditionRow, newRows);
        // 重複チェック
        this.conditionRow = Array.from(
          new Map(newRows.map((row) => [row.branchId, row])).values()
        );
        tempRows = this.conditionRow;
      } else if (this.emailCondition.length !== 0) {
        this.conditionRow = [];
      }
    },
    // 支店新規登録画面へ遷移
    add() {
      this.$router.push('/companies-groups/add');
    },
    // 支店一括登録画面へ遷移
    bulkAdd() {
      this.$router.push('/companies-groups/bulkAdd');
    },
    // 支店編集画面へ遷移
    edit(params) {
      this.$router.push({
        path: '/companies-groups/edit',
        name: 'BranchEdit',
        params: {
          id: params.branchId,
          name: params.branchName,
        },
      });
    },
    // 削除ボタン押下時処理
    async deleteExecution() {
      try {
        this.deleteErrorFlg = false;
        this.deleteLodingFlg = true;
        const restResourceService = new ApiClient();
        // 支店削除API呼び出し
        await restResourceService.deleteBranch(this.selectRow.branchId);
        await this.$cognito.deleteUsers([this.selectRow.loginId]);
        // 支店一覧再取得
        this.rows = await this.callGetBranches();
        this.conditionRow = this.rows;
      } catch (error) {
        this.errorMessage = error.message;
        this.getErrorFlg = true;
        this.deleteErrorFlg = true;
      } finally {
        this.closeModal();
        this.deleteLodingFlg = false;
      }
    },
    // 削除モーダル表示
    openModal(params) {
      window.history.pushState(null, null, null);
      window.addEventListener('popstate', this.closeModal);
      this.selectRow = params;
      this.modal = true;
    },
    // 削除モーダル非表示
    closeModal() {
      window.removeEventListener('popstate', this.closeModal);
      this.modal = false;
    },
    // CSV出力用共通関数呼出
    async callOutputCsv() {
      const columns = this.columns;
      const rows = this.conditionRow;
      // ファイル名用の現在日時
      const currentDate = new Date().getTime();
      const date = await common.getToday(currentDate);
      const fileName = '支店一覧'+date;
      common.outputCsv(columns, rows, fileName);
    },
    // 現在ページ更新
    onPageChange(params) {
      this.currentPage = params.currentPage;
      common.scrollTop();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
